import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { graphQL } from 'javascripts/shared/graphql';
import { graphQLMutations } from 'javascripts/shared/graphql/mutations';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { Modal } from 'javascripts/components/modal';

import styles from 'stylesheets/components/reviews/report_review_modal.module';

export function ReportReviewModal({ isOpen, onRequestClose, reviewId, onReportSubmitted }) {
  const [reportSubmitted, setReportSubmitted] = useState(false);

  function onFlagReview() {
    graphQL.get(graphQLMutations.reportUserReview, { userReviewId: reviewId }).then(() => {
      setReportSubmitted(true);
      onReportSubmitted();
    });
  }

  function reportNotSubmittedContent() {
    return (
      <>
        <div className={styles.headerText}>Report Review</div>
        <div className={styles.descriptionText}>
          {
            "If you've found a problem with this review and want to bring it to the attention of our moderators, please click the button below."
          }
        </div>
        <div className={styles.actionButtons}>
          <ChirpButton
            class={styles.doActionButton}
            displayStyle='yellow'
            isDisabled={reportSubmitted}
            label='Flag This Review'
            onClick={onFlagReview}
            fullWidth
          />
          <ChirpButton displayType='link' label='Cancel' onClick={onRequestClose} />
        </div>
      </>
    );
  }

  function reportSubmittedContent() {
    return (
      <>
        <div className={styles.headerText}>Thank You!</div>
        <div className={styles.descriptionText}>
          {"We'll review this post to make sure it meets our community guidelines."}
        </div>
        <div className={styles.actionButtons}>
          <ChirpButton
            class={styles.doActionButton}
            displayStyle='yellow'
            label='Close'
            onClick={onRequestClose}
            fullWidth
          />
        </div>
      </>
    );
  }

  function renderModalContent() {
    return (
      <div className={styles.reportReviewModal}>
        {reportSubmitted ? reportSubmittedContent() : reportNotSubmittedContent()}
      </div>
    );
  }

  return (
    <Modal appSelector='#reviews-app' isOpen={isOpen} onRequestClose={onRequestClose}>
      {renderModalContent()}
    </Modal>
  );
}

ReportReviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  reviewId: PropTypes.string.isRequired,
  onReportSubmitted: PropTypes.func.isRequired,
};
